export default "__VITE_ASSET__BHfr8gQX__"